/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/naming-convention */
import { Injectable } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { CustomFieldGroupService } from 'app/core/services/custom_fields_group/custom_fields_group.service';
import { DataCollectorService } from 'app/core/services/data_collector_services/data_collector_service.service';
import _ from 'lodash';
import { NgxTippyProps } from 'ngx-tippy-wrapper';
import tippy from 'tippy.js';
import { DispatchBoardService } from '../../../../../dispatch-board/src/app/components/dispatch-board/dispatch-board.service';
import { ModuleAccess } from '../../../../../dispatch-board/src/app/components/dispatch-board/dispatch-board.interface';
import { LocalStorageService } from 'app/core/services/localstorage.service';
import { CalendarService } from '../../components/services/calendar.service';
import { UtilityService } from 'app/core/services/utility_functions/utility_functions.service';

@Injectable({
  providedIn: 'root'
})
export class SharedService {

  tippyName: string;
  settingsDialogInstance: any;
  addNewAttributeRow: boolean = true;
  refreshAddNewAttributeRow: boolean = false;
  isNoTeamCreatedAlertIsOpened: boolean = false;
  refreshGridCards: boolean = true;
  moduleNameMap = { 'month' : 'JOB', 'weekday' : 'JOB' };
  jobAttributes: any = [];
  jobMonthAttributes: any = [];
  gridForm: UntypedFormGroup;
  schedulerForm: UntypedFormGroup;
  calendarForm: UntypedFormGroup;
  employeeForm: UntypedFormGroup;
  mapForm: UntypedFormGroup;
  defaultGridModuleValue: any;
  newToCalendar: any;
  moduleFormMap: any;
  mapInitialValues: any;
  defaultGridCardView = { '1': [{ 'label': 'Job #', 'originalLabel': 'Job #', 'group_uid': 'work_order_number', 'group_name': 'Default Fields', 'type': 'SINGLE_LINE', 'value': '#98458', 'selector': 'work_order_number', 'dismissable': false, 'isDefaultField': true, 'key': 'work_order_number@Job-#', 'row': 1, 'column': 1 }, { 'label': 'Job Title', 'originalLabel': 'Job Title', 'group_uid': 'work_order_title', 'group_name': 'Default Fields', 'type': 'SINGLE_LINE', 'value': 'Skiles and Sons', 'selector': 'job_title', 'dismissable': false, 'isDefaultField': true, 'key': 'work_order_title@Job-Title', 'row': 1, 'column': 2 }] };
  defaultMonthGridCardView = { '1': [{ 'label': 'Job Title', 'originalLabel': 'Job Title', 'group_uid': 'work_order_title', 'group_name': 'Default Fields', 'type': 'SINGLE_LINE', 'value': 'Skiles and Sons', 'selector': 'job_title', 'dismissable': true, 'isDefaultField': true, 'key': 'work_order_title@Job-Title', 'row': 1, 'column': 2 }] };

  constructor(
    private _dataCollectorService: DataCollectorService,
    private _customFieldGroupService: CustomFieldGroupService,
    private formBuilder: UntypedFormBuilder,
    private _dispatchBoardService: DispatchBoardService,
    private _localStorageService: LocalStorageService,
    private calendarService: CalendarService,
    private utilitySevice: UtilityService
  ) {

  }

  async initateForms(): Promise<void> {
    this.calendarForm = this.formBuilder.group({
      primary_color: ['jobStatus', Validators.required],
      secondary_color: ['team', Validators.required],
      card_view: [this.defaultGridCardView, Validators.required],
      month_card_view: [this.defaultMonthGridCardView, Validators.required],
      display: this.formBuilder.group({
        multiple_teams: [false, Validators.required],
        business_hours_only: [false, Validators.required],
        duration_between_jobs: [false, Validators.required],
        job_summary: [false, Validators.required],
        weekends: [false, Validators.required],
        week_numbers: [false, Validators.required],
        defaultCalendarView: ['week', Validators.required],
        weekStartDay: [1, Validators.required],
        show_timeoff:[true, Validators.required]
      }),
    });
    this.moduleFormMap = { 'CALENDAR':this.calendarForm};
    this.calendarService.defaultJobAttributes = await this.getDefaultAndCustomFields('GRID', true);
  }

  async getJobAttributes(): Promise<any> {
    this.jobAttributes = await this.getDefaultAndCustomFields('weekday');
    this.jobMonthAttributes = await this.getDefaultAndCustomFields('month');
  }

  updateFormFields(form: any, formControlName: string, value: any): void {
    const formValue: any = {};
    formValue[formControlName] = value;
    form.patchValue(formValue);
  }

  getDefaultAndCustomFields(moduleName: string, onlyDefaultFields: boolean = false): Promise<any> {
    return new Promise(async (resolve) => {
      let customeFields = [];
      let defaultFields = this.getDefaultFields(moduleName);
      defaultFields = defaultFields.map(ele => ({ ...ele, isDefaultField: true, displayKeyValue: ele?.displayKey ? this.utilitySevice.getLocaleValue(ele.displayKey) : ele.label }));
      if (!onlyDefaultFields) {
        if (moduleName !== 'ROUTE') {
          customeFields = this._customFieldGroupService.constructCustomFieldUpdateObject(await this.getCustomFields(this.moduleNameMap[moduleName]));
        }
        customeFields = customeFields.map(ele => ({
          ...ele, isDefaultField: false, group_name: ele.group_name.replace('Custom fields - ', ''), displayKeyValue: ele.label,
          tooltip: `${ele.label} (${ele.group_name})`, originalLabel: ele.label, label: `${ele.label} (${ele.group_name.replace('Custom fields - ', '')})`
        }));
      }
      resolve([...defaultFields, ...customeFields]
        .map(ele => ({ ...ele, key: this.generateKey(ele.group_uid, ele.label) })));
    });
  }
  
  generateKey(group_uid: string, label: string): string {
    group_uid = group_uid === '' ? 'default_uid' : group_uid;
    return group_uid.trim() + '@' + label.trim().replaceAll(' ', '-');
  }

  addMissingKey(obj1: any, obj2: any): any {
    const skipKeys = ['due_date_type', 'schedule_date_type'];
    Object.keys(obj2).forEach((key) => {
      if (!obj1.hasOwnProperty(key) && !skipKeys.includes(obj2)) {
        obj1[key] = '';
      }
    });
    return obj1;
  }

  isEqualObjects(object1: any, object2: any, skipKeys?: any[]): any {
    if(skipKeys && skipKeys.length > 0) {
      skipKeys.forEach((key: any) => {
        delete object1[key];
        delete object2[key];
      });
    }
    return !!_([object1]).filter(object2).size();
  }

  getCustomFields(moduleName: string): Promise<any> {
    return new Promise((resolve, reject) => {
      // eslint-disable-next-line @typescript-eslint/no-unused-expressions
      this._dataCollectorService.getData(this._customFieldGroupService.getModuleCustomFieldsUrl(moduleName))
        .subscribe((response) => {
          resolve(response.data);
        }),
        (_err: any): any => {
          resolve([] as any);
        };
    });
  }

  createTippy(target: Element, options: NgxTippyProps): any {
    if (target) {
      return tippy(target, options);
    }
  }

  saveMetaData(): void {
    const calendarData = this.calendarForm.value;
    this.defaultGridModuleValue = this._localStorageService.getLocalStorage('calendar_metadata') || {};
    const settingsData = { 'calendar': calendarData };
    if (!_.isEqual(this.defaultGridModuleValue, settingsData) || this.newToCalendar) {
      const payload = { 'meta_data': { 'module': 'SCHEDULE', 'key': 'CALENDAR', 'value': JSON.stringify(settingsData) } };
      this._dataCollectorService.postData(this.calendarService.metaDataUrl, payload)
        .subscribe((response) => {
          this._localStorageService.setLocalStorage('calendar_metadata', settingsData);
          this.defaultGridModuleValue = settingsData;
          this.settingsDialogInstance.close(settingsData);
        });
    }
    else {
      this.settingsDialogInstance?.close();
    }
  }

  initAddAttributeRowBtn(): void {
    this.addNewAttributeRow = !this.addNewAttributeRow;
    setTimeout(() => {
      this.addNewAttributeRow = !this.addNewAttributeRow;
    });
  }

  getDefaultFields(moduleName: string): any[] {
    const defaultFields = {
      'JOB': [
        {
          'id': 1,
          'label': 'Job #',
          'group_uid': 'work_order_number',
          'group_name': 'Default Fields',
          'type': 'SINGLE_LINE',
          'value': '#98458',
          'selector': 'work_order_number',
          'dismissable': moduleName === 'month' ? true : false,
          'displayKey': 'dispatchBoard.grid.tbar.sort.job_id'
        },
        {
          'id': 2,
          'label': 'Job Title',
          'group_uid': 'work_order_title',
          'group_name': 'Default Fields',
          'type': 'SINGLE_LINE',
          'value': 'Skiles and Sons',
          'selector': 'job_title',
          'dismissable':  moduleName === 'month' ? true : false,
           'displayKey': 'text.job_title'
        },
        {
          'id': 3,
          'label': 'Job Category',
          'group_uid': 'work_order_category',
          'group_name': 'Default Fields',
          'type': 'SINGLE_LINE',
          'value': 'Home cleaning',
          'selector': 'job_category.category_name',
          'icon': 'ti ti-category-2',
          'dismissable': true,
          'displayKey': 'job.category'
        },
        {
          'id': 4,
          'label': 'Current Job Status',
          'group_uid': 'current_work_order_status',
          'group_name': 'Default Fields',
          'type': 'SINGLE_LINE',
          'value': 'Started',
          'status_color_selector': 'current_job_status.status_color',
          'selector': 'current_job_status.status_name',
          'dismissable': true,
           'displayKey': 'dispatchBoard.settings.label.current_job_status'
        },
        {
          'id': 5,
          'label': 'Priority',
          'group_uid': 'work_order_priority',
          'group_name': 'Default Fields',
          'type': 'SINGLE_LINE',
          'value': 'Medium',
          'selector': 'job_priority',
          'dismissable': true,
          'displayKey': 'text.priority'
        },
        {
          'id': 6,
          'label': 'Property',
          'group_uid': 'work_order_property',
          'group_name': 'Default Fields',
          'type': 'SINGLE_LINE',
          'value': 'Real Estate',
          'selector': 'property.property_name',
          'icon': 'ti ti-building-estate',
          'dismissable': true,
          'displayKey': 'text.property'
        },
        {
          'id': 7,
          'label': 'Actual Date & Time',
          'group_uid': 'work_order_actual_date',
          'group_name': 'Default Fields',
          'type': 'DATE',
          'value': '02/02/2024 09:00 -> 11:30',
          'selector': ['actual_start_time', 'actual_end_time'],
          'icon': 'ti ti-calendar',
          'dismissable': true,
          'displayKey': 'dispatchBoard.settings.label.actual_date'
        },
        {
          'id': 8,
          'label': 'Created Date',
          'group_uid': 'work_order_created_date',
          'group_name': 'Default Fields',
          'type': 'DATE',
          'value': '09/12/2023',
          'selector': 'created_at',
          'icon': 'ti ti-calendar-plus',
          'dismissable': true,
          'displayKey': 'customer.filter.created_at'
        },
        {
          'id': 9,
          'label': 'Customer Name',
          'group_uid': 'work_order_customer_name',
          'group_name': 'Default Fields',
          'type': 'SINGLE_LINE',
          'value': 'Jose-Manuel',
          'selector': ['customer.customer_first_name', 'customer.customer_last_name'],
          'icon': 'ti ti-user-circle',
          'dismissable': true,
          'displayKey': 'text.customer_name'
        },
        {
          'id': 10,
          'label': 'Organization Name',
          'group_uid': 'work_order_organization_name',
          'group_name': 'Default Fields',
          'type': 'SINGLE_LINE',
          'value': 'Meta',
          'selector': 'organization.organization_name',
          'icon': 'ti ti-building',
          'dismissable': true,
          'displayKey': 'text.organization_name'
        },
        {
          'id': 11,
          'label': 'Service Address - Street',
          'group_uid': 'service_address_street',
          'group_name': 'Default Fields',
          'type': 'SINGLE_LINE',
          'value': '2nd Avenue',
          'selector': 'customer_address.street',
          'icon': 'ti ti-building',
          'dismissable': true,
          'displayKey': 'dispatchBoard.settings.label.service_address_street'
        },
        {
          'id': 12,
          'label': 'Service Address - City & State',
          'group_uid': 'service_address_city_state',
          'group_name': 'Default Fields',
          'type': 'SINGLE_LINE',
          'value': 'Washington',
          'selector': ['customer_address.city', 'customer_address.state'],
          'icon': 'ti ti-location',
          'dismissable': true,
          'displayKey': 'dispatchBoard.settings.label.service_address_city_state'
        },
        {
          'id': 13,
          'label': 'Service Address - Zipcode',
          'group_uid': 'service_address_zipcode',
          'group_name': 'Default Fields',
          'type': 'SINGLE_LINE',
          'value': '20001',
          'selector': 'customer_address.zip_code',
          'icon': 'ti ti-map-pin',
          'dismissable': true,
          'displayKey': ''
        },
        {
          'id': 14,
          'label': 'Assigned To',
          'group_uid': 'work_order_assigned_to',
          'group_name': 'Default Fields',
          'type': 'SINGLE_LINE',
          'value': 'John Charles',
          'selector': 'assigned_to',
          'icon': 'ti ti-users',
          'dismissable': true,
          'displayKey': 'text.assigned_to'
        },
        {
          'id': 15,
          'label': 'Skillsets',
          'group_uid': 'work_order_skillsets',
          'group_name': 'Default Fields',
          'type': 'SINGLE_LINE',
          'value': 'Plumbing',
          'selector': 'skills',
          'icon': '',
          'dismissable': true,
          'displayKey': 'dispatchBoard.settings.label.skillsets'
        },
        {
          'id': 16,
          'label': 'Scheduled Date & Time',
          'group_uid': 'work_order_scheduled_date',
          'group_name': 'Default Fields',
          'type': 'DATE',
          'value': '02/02/2024 09:00 AM -> 02/02/2024 10:00 AM',
          'selector': ['scheduled_start_time', 'scheduled_end_time'],
          'icon': 'ti ti-calendar-time',
          'dismissable': true,
          'displayKey': 'dispatchBoard.settings.label.scheduled_start_date_time'
        },
        {
          'id': 17,
          'label': 'Due Date',
          'group_uid': 'work_order_due_date',
          'group_name': 'Default Fields',
          'type': 'DATE',
          'value': '02/02/2024',
          'selector': 'due_date',
          'icon': 'ti ti-calendar-due',
          'dismissable': true,
          'displayKey': 'due.date.text'
        },
        {
          'id': 18,
          'label': 'Service Territory',
          'group_uid': 'service_territory',
          'group_name': 'Default Fields',
          'type': 'SINGLE_LINE',
          'value': 'North East Region',
          'selector': 'service_territory.territory.territory_name',
          'icon': 'ti ti-compass',
          'dismissable': true,
          'displayKey': 'dispatch.filter.service_territory.label'
        },
        {
          'id': 19,
          'label': 'Tags',
          'group_uid': 'job_tags',
          'group_name': 'Default Fields',
          'type': 'SINGLE_LINE',
          'value': 'Needs Triage',
          'selector': 'job_tags',
          'icon': 'ti ti-tag',
          'dismissable': true,
          'displayKey': 'text.tags'
        }
      ]
    };

    if(this.calendarService.moduleAccess.project) {
      const projectAttribute = {
        'id': 20,
        'label': 'Project',
        'group_uid': 'job_project',
        'group_name': 'Default Fields',
        'type': 'SINGLE_LINE',
        'value': 'Kitchen Installation - Henry',
        'icon': 'ti ti-clipboard-check',
        'selector': 'project',
        'dismissable': true,
        'displayKey': 'text.project'
      };

      defaultFields.JOB.push(projectAttribute);

    }

    return defaultFields[this.moduleNameMap[moduleName]] || [];
  }
}
export interface SelectedCardDetails {
  label: string;
  key: string;
  row: number;
  column: number;
  dismissable: boolean;
}
